import { Module } from "types/generated";

export const canAccessModule = (module: Module) => {
  return module.canRead;
};
